<template>
  <div class="circle-filter-tool">
    <div class="circle-filter-tool-label">{{ labels.min }}</div>
    <slider
      v-model="internalValue"
      class="circle-filter-tool-slider"
      :min="min"
      :max="max"
      :step="step"
      :colors="colors"
      :thumb-color="thumbColor"
      :value-display="valueDisplay"
    />
    <div class="circle-filter-tool-label">{{ labels.max }}</div>
  </div>
</template>

<script>
import Slider from './slider'
export default {
  components: {
    Slider
  },
  props: {
    value: {
      type: Number,
      default: 0.5
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.1
    },
    labels: {
      type: Object,
      default: () => ({
        min: '0%',
        max: '100%'
      })
    },
    colors: {
      type: Array,
      default: undefined
    },
    thumbColor: {
      type: String,
      default: undefined
    },
    valueDisplay: {
      type: Function,
      default: value => value * 100 + '%'
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    internalValue(newValue) {
      this.$emit('input', parseFloat(newValue))
    }
  }
}
</script>

<style lang="scss" scoped>
.circle-filter-tool {
  &-label {
    font-size: 12px;
    font-weight: 500;
    line-height: 2.83;
    color: #808080;
  }
  &-slider {
    margin: 0 12px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
